import React from 'react';

const ProgressBar = ({
  current,
  target,
  unit,
  size = 'md',
  showPercentage = false,
  showValues = false,
  targetMin,
  targetMax
}) => {
  const percentage = Math.min(Math.max((current / target) * 100, 0), 100);

  const heightClass = size === 'sm' ? 'h-1.5' : size === 'lg' ? 'h-4' : 'h-2.5';

  let colorClass = 'bg-accent-gold';
  if (percentage >= 100) colorClass = 'bg-green-500';
  else if (percentage < 30) colorClass = 'bg-red-500';
  else if (percentage < 70) colorClass = 'bg-yellow-500';

  return (
    <div className="w-full">
      {(showPercentage || showValues) && (
        <div className="flex justify-between text-xs mb-1">
          {showValues && (
            <span className="text-gray-600 dark:text-gray-400 font-medium">
              {current.toLocaleString()} {unit && unit}
            </span>
          )}
          {showPercentage && (
            <span className="font-bold text-gray-800 dark:text-gray-200">
              {percentage.toFixed(1)}%
            </span>
          )}
        </div>
      )}
      <div
        className={`w-full bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden ${heightClass}`}
      >
        <div
          className={`${heightClass} ${colorClass} transition-all duration-500 ease-out`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      {showValues && target && (
        <div className="flex justify-end mt-1">
          <span className="text-xs text-gray-500">Target: {target.toLocaleString()}</span>
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
